import React from "react";
import { Faq } from "../svg/other";
import Logo from "../../images/Darklogo.svg";
import { Link } from "gatsby";

export function QueNav() {
  return (
    <nav className="que-navigation">
      <div className="que-nav">
      <Link className="m-auto" to="/">
          <img className="que-logo" src={Logo} alt="Digital Comparison" />
        </Link>
        <Link href="#queFAQSection">
          <Faq />
        </Link>
      </div>
    </nav>
  );
}
